import {Chip, Image} from "@heroui/react";
import PropTypes from "prop-types";

const BlogCard = ({title, category, date, img, cardHandler}) => {
    return (
        <div className="blog-card border rounded-lg p-2 cursor-pointer" onClick={cardHandler}>
            <Image
                src={img}
                alt="Blog Image"
                width={800}
                height={200}
                lazy={true}
                className="rounded-md object-cover"
            />
            <Chip size='sm' color='default' className={'mt-3 mb-2'} radius="sm">{category}</Chip>
            <h4 className={'font-semibold line-clamp-2'}>{title}</h4>
            <p className={'text-tiny text-neutral-400 mt-4 w-full text-end'}>{date}</p>
        </div>
    );
};

BlogCard.propTypes = {
    title: PropTypes.string,
    category: PropTypes.string,
    date: PropTypes.string,
    img: PropTypes.string,
    cardHandler: PropTypes.func,
};

export default BlogCard;
